module.exports = __webpack_public_path__ + "audio-27e20f9beb64.m4a";